module.exports = __webpack_public_path__ + "media/images/certification/checked-96254675996c28f07c4d81c84c855bb5.svg";